<template>
    <div class="new-owners-garanty">
        <div class="container">
            <h2 v-html="pageSetup.owner_garanty.title"></h2>
            <div class="desc-title"><p v-html="pageSetup.owner_garanty.desc"></p></div>
            <div class="cards-items">
                <div class="item" v-for="item in pageSetup.owner_garanty.contacts">
                    <div class="item-img" :style="'background-image: url(' + item.img + ')'"></div>
                    <div class="full-info">
                        <h3 v-html="item.city"></h3>
                        <div class="adres-info">
                            <div class="info-item">
                                <svgIcon name="clock" class="icon-clock"/>
                                <p>{{ item.time }}</p>
                                <span>{{ item.desc }}</span>
                            </div>
                            <div class="info-item">
                                <svgIcon name="mobile" class="icon-mobile"/>
                                <div class="phones-items">
                                    <a :href="'tel:' + phone.telefony" v-for="phone in item.phone">{{ phone.telefony }}</a>
                                </div>
                            </div>
                            <div class="info-item">
                                <svgIcon name="mail" class="icon-mail"/>
                                <strong>{{ item.email }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'new-owners-main-garanty',
        components: {
            svgIcon
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            pageSetup: 'loadNewOwnersPage',
        }),
        methods: {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/new-owners/new-owners-garanty.scss';
    @import '@/styles/components/new-owners/respond/new-owners-garanty-respond.scss';
    // @import '@/styles/components/about/respond/about-us-section-respond.scss';
</style>